import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = { class: "flex items-center justify-between mb-1 font-bold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Revenue", -1)
const _hoisted_4 = { class: "flex items-center justify-between mb-1 font-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Base cost", -1)
const _hoisted_6 = { class: "flex items-center justify-between mb-1 font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Hold fee", -1)
const _hoisted_8 = { class: "flex items-center justify-between mb-1 font-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Handing fee", -1)
const _hoisted_10 = { class: "flex items-center justify-between pl-2 mb-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Payment fee ")
const _hoisted_12 = { class: "flex items-center justify-between pl-2 mb-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Processing fee ")
const _hoisted_14 = { class: "flex items-center justify-between pl-2 mb-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Platform fee ")
const _hoisted_16 = { class: "flex items-center justify-between pl-2 mb-1" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Design fee ")
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-between font-bold"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Refunds/ Dispute Fee", -1)
const _hoisted_20 = { class: "flex items-center justify-between font-bold" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Profit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!

  return (_ctx.order.profit)
    ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.title), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatterDollars(_ctx.order.grandTotal)), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, "-" + _toDisplayString(_ctx.formatterDollars(_ctx.order.sellerAmount)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, "-" + _toDisplayString(_ctx.formatterDollars(_ctx.order.holdFeeValue)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, " -" + _toDisplayString(_ctx.formatterDollars(
            _ctx.order.paymentFeeValue +
              _ctx.order.processingFeeValue +
              _ctx.order.platformFeeValue +
              _ctx.order.designFeeValue
          )), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, "-" + _toDisplayString(_ctx.formatterDollars(_ctx.order.paymentFeeValue)), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", null, "-" + _toDisplayString(_ctx.formatterDollars(_ctx.order.processingFeeValue)), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, "-" + _toDisplayString(_ctx.formatterDollars(_ctx.order.platformFeeValue)), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", null, "-" + _toDisplayString(_ctx.formatterDollars(_ctx.order.designFeeValue)), 1)
          ]),
          (_ctx.order.refundDisputeFeeValue > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("span", null, "-" + _toDisplayString(_ctx.formatterDollars(_ctx.order.refundDisputeFeeValue)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatterDollars(_ctx.order.profit)), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}